import { useRef, useEffect, useCallback, useMemo } from "react";
// This hook was inspired by https://tobbelindstrom.com/blog/useEventListener/
export var useEventListener = function (_a) {
    var type = _a.type, listener = _a.listener, element = _a.element;
    var savedListener = useRef();
    var el = useMemo(function () { return element || window; }, [element]);
    useEffect(function () {
        savedListener.current = listener;
    }, [listener]);
    var handleEventListener = useCallback(function (event) {
        var _a;
        (_a = savedListener.current) === null || _a === void 0 ? void 0 : _a.call(savedListener, event);
    }, []);
    useEffect(function () {
        var event = type;
        el === null || el === void 0 ? void 0 : el.addEventListener(event, handleEventListener);
        return function () { return el === null || el === void 0 ? void 0 : el.removeEventListener(event, handleEventListener); };
    }, [type, el, handleEventListener]);
};
